import { Box, CircularProgress } from '@mui/material';
import React from 'react';

const AbsoluteLoading = () => {
  return (
    <Box
      display={'flex'}
      align="center"
      justify="center"
      style={{
        height: '100%',
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        background: '#ffffff80',
        zIndex: 10,
        flexDirection: 'column',
        gap: 12,
      }}
    >
      <CircularProgress size={50} />
    </Box>
  );
};

export default AbsoluteLoading;
